import React, { createContext, useContext, useEffect, useState } from 'react';
import { auth, googleProvider } from '../firebaseConfig';
import { signInWithPopup, signOut, onAuthStateChanged } from 'firebase/auth';
import axios from 'axios';

// Context Oluşturuluyor
const AuthContext = createContext();

export const useAuth = () => {
    return useContext(AuthContext);
};

export const AuthProvider = ({ children }) => {
    const [currentUser, setCurrentUser] = useState(null);
    const [dbUser, setDbUser] = useState(null); // Veritabanındaki ekstra profil bilgileri
    const [loading, setLoading] = useState(true);

    // Google ile Giriş Yap
    const loginWithGoogle = async () => {
        try {
            const result = await signInWithPopup(auth, googleProvider);
            const user = result.user;
            
            // Backend'e kullanıcı bilgisini gönder ki MongoDB'ye kaydetsin/güncellesin
            const dbRes = await axios.post(`${process.env.REACT_APP_API_URL || 'http://localhost:5000'}/api/auth/google-login`, {
                uid: user.uid,
                email: user.email,
                displayName: user.displayName,
                photoURL: user.photoURL
            });
            
            setDbUser(dbRes.data.user);
            localStorage.setItem('sahalive_player_session', JSON.stringify(dbRes.data.user));
            return dbRes.data;
        } catch (error) {
            console.error("Google Login Error:", error);
            throw error;
        }
    };

    // Kullanıcı Adı ve Şifre ile Giriş Yap
    const loginWithCredentials = async (usernameOrEmail, password, code = undefined) => {
        try {
            const dbRes = await axios.post(`${process.env.REACT_APP_API_URL || 'http://localhost:5000'}/api/auth/login`, {
                usernameOrEmail,
                password,
                code
            });
            
            const user = dbRes.data.user;
            setDbUser(user);
            localStorage.setItem('sahalive_player_session', JSON.stringify(user));
            return user;
        } catch (error) {
            console.error("Credentials Login Error:", error);
            throw error;
        }
    };

    // Çıkış Yap
    const logout = async () => {
        try {
            await signOut(auth);
            localStorage.removeItem('sahalive_player_session');
            localStorage.removeItem('sahalive_session');
            localStorage.removeItem('superAdmin');
            setDbUser(null);
            setCurrentUser(null);
        } catch (error) {
            console.error("Logout Error:", error);
        }
    };

    // Tesis Sahibi / Eski admin girişi yapanlar için sahte bir çıkış simülasyonu gerekirse buraya ekleyebiliriz

    useEffect(() => {
        // İlk yüklemede yerel oyuncu oturumunu yükle
        const localSession = localStorage.getItem('sahalive_player_session');
        if (localSession) {
            try {
                setDbUser(JSON.parse(localSession));
            } catch (e) {
                localStorage.removeItem('sahalive_player_session');
            }
        }

        const unsubscribe = onAuthStateChanged(auth, async (user) => {
            setCurrentUser(user);
            
            if (user) {
                // Kullanıcı değiştiğinde veritabanından güncel profilini çek
                try {
                    const dbRes = await axios.post(`${process.env.REACT_APP_API_URL || 'http://localhost:5000'}/api/auth/google-login`, {
                        uid: user.uid,
                        email: user.email,
                        displayName: user.displayName,
                        photoURL: user.photoURL
                    });
                    setDbUser(dbRes.data.user);
                    localStorage.setItem('sahalive_player_session', JSON.stringify(dbRes.data.user));
                } catch (error) {
                    console.error("Failed to fetch user profile from DB", error);
                }
            } else {
                // Eğer hem Firebase oturumu yoksa hem de yerel kullanıcı adı/şifre oturumu yoksa dbUser'ı sıfırla
                const hasLocalSession = localStorage.getItem('sahalive_player_session');
                if (!hasLocalSession) {
                    setDbUser(null);
                }
            }

            setLoading(false);
        });

        return unsubscribe;
    }, []);

    const value = {
        currentUser,
        dbUser,
        setDbUser,
        loginWithGoogle,
        loginWithCredentials,
        logout
    };

    return (
        <AuthContext.Provider value={value}>
            {!loading && children}
        </AuthContext.Provider>
    );
};
